<template>
  <div class="container my-gpx-upload">
    <h1 class="hover" v-to="'/myregistrations/' + id">← Voltar para a inscrição</h1>

    <div v-if="loading" class="muted">Carregando...</div>

    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

    <div v-else-if="purshaseProduct">
      <div class="event-summary" v-if="eventInfo">
        <h2>{{ eventInfo.name }}</h2>
        <p v-if="categoryName" class="category">{{ categoryName }}</p>
        <p v-if="teamName" class="team-name">🏃 Equipe: <strong>{{ teamName }}</strong></p>
        <p v-if="eventInfo.gpxUploadOpenAt && eventInfo.gpxUploadCloseAt" class="window">
          Janela de envio:
          {{ formatDate(eventInfo.gpxUploadOpenAt) }}
          até
          {{ formatDate(eventInfo.gpxUploadCloseAt) }}
        </p>
      </div>

      <team-gpx-tab
        v-if="team"
        :team-id="team.id"
        :event-info="eventInfo"
        :competitors="competitors"
      />

      <div v-else class="alert alert-warning">
        Esta inscrição não possui equipe vinculada para envio de GPX.
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import TeamGpxTab from '@/components/Team/team-gpx-tab.vue';

export default {
  name: 'my-gpx-upload',
  components: { TeamGpxTab },

  data() {
    return {
      loading: true,
      error: null,
      eventInfo: null,
    };
  },

  computed: {
    id() {
      return parseInt(this.$route.params.id);
    },
    purshaseProduct() {
      return this.$store.getters['PurchaseStore/purshaseProductById'](this.id);
    },
    team() {
      // The store getter rebuilds purshaseProduct.team as an ARRAY
      // (teamForPurshaseProduct does _.filter). Unwrap to the single team.
      const t = this.purshaseProduct && this.purshaseProduct.team;
      if (!t) return null;
      return Array.isArray(t) ? (t[0] || null) : t;
    },
    competitors() {
      // Members in this app are split between Competitor (on the team) and
      // Member (on the purchase). The team owner cares about competitors —
      // those are who actually run. Surface both lists if present.
      if (!this.purshaseProduct) return [];
      const nameOf = (o) => {
        const i = o.infos || {};
        return o.name || i.name || i['nome'] || i['nome-atleta'] || ('Atleta #' + o.id);
      };
      const fromTeam = ((this.team && this.team.competitors) || []).map((c) => ({
        id: c.id, name: nameOf(c),
      }));
      const fromMembers = (this.purshaseProduct.members || []).map((m) => ({
        id: m.id, name: nameOf(m),
      }));
      // Prefer team.competitors; fall back to members.
      return fromTeam.length ? fromTeam : fromMembers;
    },
    // Category/competition label — purshaseProduct.name is
    // "<event> / <competition> / <category>"; strip the leading event part.
    categoryName() {
      const n = this.purshaseProduct && this.purshaseProduct.name;
      if (!n) return '';
      return n.replace(/^[^/]*?\//, '').trim();
    },
    teamName() {
      const infos = this.team && this.team.infos;
      if (!infos) return '';
      return infos['nome-equipe'] || infos['nome'] || infos['name'] || '';
    },
  },

  async created() {
    try {
      let res = await this.$store.dispatch(
        'PurchaseStore/loadRegistrationsById',
        this.id
      );
      if (res === false) {
        this.error = 'Não foi possível carregar a inscrição';
        return;
      }
      if (this.purshaseProduct && this.purshaseProduct.eventId) {
        const ev = await api.getJSONAsync('events/' + this.purshaseProduct.eventId);
        if (ev && !ev.error) this.eventInfo = ev;
      }
    } finally {
      this.loading = false;
    }
  },

  methods: {
    formatDate(s) {
      if (!s) return '—';
      return new Date(s).toLocaleString('pt-BR');
    },
  },
};
</script>

<style scoped>
.my-gpx-upload {
  padding: 1em 0;
}
.event-summary {
  margin: 1em 0 2em;
  padding: 1em;
  background: rgba(23, 162, 184, 0.07);
  border-radius: 8px;
}
.event-summary h2 {
  margin: 0 0 0.2em;
}
.category {
  margin: 0 0 0.3em;
  font-size: 1.05em;
  font-weight: 600;
  color: #17a2b8;
}
.team-name {
  margin: 0 0 0.5em;
  color: #333;
}
.window {
  color: #555;
  margin: 0;
}
.muted {
  color: #888;
}
.alert {
  padding: 0.8em 1em;
  border-radius: 4px;
  margin: 1em 0;
}
.alert-danger {
  background: #f8d7da;
  color: #842029;
}
.alert-warning {
  background: #fff3cd;
  color: #664d03;
}
</style>
